/**
 * Resize function without multiple trigger
 *
 * Usage:
 * $(window).smartresize(function(){
 *     // code here
 * });
 */

/* @license
 * jQuery.print, version 1.5.1
 *  (c) Sathvik Ponangi, Doers' Guild
 * Licence: CC-By (http://creativecommons.org/licenses/by/3.0/)
 *--------------------------------------------------------------------------*/
(function ($) {
  "use strict";
  // A nice closure for our definitions
  function getjQueryObject(string) {
    // Make string a vaild jQuery thing
    var jqObj = $("");
    try {
      jqObj = $(string)
        .clone();
    } catch (e) {
      jqObj = $("<span />")
        .html(string);
    }
    return jqObj;
  }

  function printFrame(frameWindow, content, options) {
    // Print the selected window/iframe
    var def = $.Deferred();
    try {
      frameWindow = frameWindow.contentWindow || frameWindow.contentDocument || frameWindow;
      var wdoc = frameWindow.document || frameWindow.contentDocument || frameWindow;
      if (options.doctype) {
        wdoc.write(options.doctype);
      }
      wdoc.write(content);
      wdoc.close();
      var printed = false;
      var callPrint = function () {
        if (printed) {
          return;
        }
        // Fix for IE : Allow it to render the iframe
        frameWindow.focus();
        try {
          // Fix for IE11 - printng the whole page instead of the iframe content
          if (!frameWindow.document.execCommand('print', false, null)) {
            // document.execCommand returns false if it failed -http://stackoverflow.com/a/21336448/937891
            frameWindow.print();
          }
          // focus body as it is losing focus in iPad and content not getting printed
          $('body').focus();
        } catch (e) {
          frameWindow.print();
        }
        frameWindow.close();
        printed = true;
        def.resolve();
      }
      // Print once the frame window loads - seems to work for the new-window option but unreliable for the iframe
      $(frameWindow).on("load", callPrint);
      // Fallback to printing directly if the frame doesn't fire the load event for whatever reason
      setTimeout(callPrint, options.timeout);
    } catch (err) {
      def.reject(err);
    }
    return def;
  }

  function printContentInIFrame(content, options) {
    var $iframe = $(options.iframe + "");
    var iframeCount = $iframe.length;
    if (iframeCount === 0) {
      // Create a new iFrame if none is given
      $iframe = $('<iframe height="0" width="0" border="0" wmode="Opaque"/>')
        .prependTo('body')
        .css({
          "position": "absolute",
          "top": -999,
          "left": -999
        });
    }
    var frameWindow = $iframe.get(0);
    return printFrame(frameWindow, content, options)
      .done(function () {
        // Success
        setTimeout(function () {
          // Wait for IE
          if (iframeCount === 0) {
            // Destroy the iframe if created here
            $iframe.remove();
          }
        }, 1000);
      })
      .fail(function (err) {
        // Use the pop-up method if iframe fails for some reason
        console.error("Failed to print from iframe", err);
        printContentInNewWindow(content, options);
      })
      .always(function () {
        try {
          options.deferred.resolve();
        } catch (err) {
          console.warn('Error notifying deferred', err);
        }
      });
  }

  function printContentInNewWindow(content, options) {
    // Open a new window and print selected content
    var frameWindow = window.open();
    return printFrame(frameWindow, content, options)
      .always(function () {
        try {
          options.deferred.resolve();
        } catch (err) {
          console.warn('Error notifying deferred', err);
        }
      });
  }

  function isNode(o) {
    /* http://stackoverflow.com/a/384380/937891 */
    return !!(typeof Node === "object" ? o instanceof Node : o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string");
  }
  $.print = $.fn.print = function () {
    // Print a given set of elements
    var options, $this, self = this;
    // console.log("Printing", this, arguments);
    if (self instanceof $) {
      // Get the node if it is a jQuery object
      self = self.get(0);
    }
    if (isNode(self)) {
      // If `this` is a HTML element, i.e. for
      // $(selector).print()
      $this = $(self);
      if (arguments.length > 0) {
        options = arguments[0];
      }
    } else {
      if (arguments.length > 0) {
        // $.print(selector,options)
        $this = $(arguments[0]);
        if (isNode($this[0])) {
          if (arguments.length > 1) {
            options = arguments[1];
          }
        } else {
          // $.print(options)
          options = arguments[0];
          $this = $("html");
        }
      } else {
        // $.print()
        $this = $("html");
      }
    }
    // Default options
    var defaults = {
      globalStyles: true,
      mediaPrint: false,
      stylesheet: null,
      noPrintSelector: ".no-print",
      iframe: true,
      append: null,
      prepend: null,
      manuallyCopyFormValues: true,
      deferred: $.Deferred(),
      timeout: 750,
      title: null,
      doctype: '<!doctype html>'
    };
    // Merge with user-options
    options = $.extend({}, defaults, (options || {}));
    var $styles = $("");
    if (options.globalStyles) {
      // Apply the stlyes from the current sheet to the printed page
      $styles = $("style, link, meta, base, title");
    } else if (options.mediaPrint) {
      // Apply the media-print stylesheet
      $styles = $("link[media=print]");
    }
    if (options.stylesheet) {
      // Add a custom stylesheet if given
      $styles = $.merge($styles, $('<link rel="stylesheet" href="' + options.stylesheet + '">'));
    }
    // Create a copy of the element to print
    var copy = $this.clone();
    // Wrap it in a span to get the HTML markup string
    copy = $("<span/>")
      .append(copy);
    // Remove unwanted elements
    copy.find(options.noPrintSelector)
      .remove();
    // Add in the styles
    copy.append($styles.clone());
    // Update title
    if (options.title) {
      var title = $("title", copy);
      if (title.length === 0) {
        title = $("<title />");
        copy.append(title);
      }
      title.text(options.title);
    }
    // Appedned content
    copy.append(getjQueryObject(options.append));
    // Prepended content
    copy.prepend(getjQueryObject(options.prepend));
    if (options.manuallyCopyFormValues) {
      // Manually copy form values into the HTML for printing user-modified input fields
      // http://stackoverflow.com/a/26707753
      copy.find("input")
        .each(function () {
          var $field = $(this);
          if ($field.is("[type='radio']") || $field.is("[type='checkbox']")) {
            if ($field.prop("checked")) {
              $field.attr("checked", "checked");
            }
          } else {
            $field.attr("value", $field.val());
          }
        });
      copy.find("select").each(function () {
        var $field = $(this);
        $field.find(":selected").attr("selected", "selected");
      });
      copy.find("textarea").each(function () {
        // Fix for https://github.com/DoersGuild/jQuery.print/issues/18#issuecomment-96451589
        var $field = $(this);
        $field.text($field.val());
      });
    }
    // Get the HTML markup string
    var content = copy.html();
    // Notify with generated markup & cloned elements - useful for logging, etc
    try {
      options.deferred.notify('generated_markup', content, copy);
    } catch (err) {
      console.warn('Error notifying deferred', err);
    }
    // Destroy the copy
    copy.remove();
    if (options.iframe) {
      // Use an iframe for printing
      try {
        printContentInIFrame(content, options);
      } catch (e) {
        // Use the pop-up method if iframe fails for some reason
        console.error("Failed to print from iframe", e.stack, e.message);
        printContentInNewWindow(content, options);
      }
    } else {
      // Use a new window for printing
      printContentInNewWindow(content, options);
    }
    return this;
  };
})(jQuery);
(function ($, sr) {
  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
    var timeout

    return function debounced() {
      var obj = this,
        args = arguments

      function delayed() {
        if (!execAsap)
          func.apply(obj, args)
        timeout = null
      }

      if (timeout)
        clearTimeout(timeout)
      else if (execAsap)
        func.apply(obj, args)

      timeout = setTimeout(delayed, threshold || 100)
    }
  }

  // smartresize
  jQuery.fn[sr] = function (fn) {
    return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr)
  }

})(jQuery, 'smartresize')
/**
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var CURRENT_URL = window.location.href.split('#')[0].split('?')[0],
  $BODY = $('body'),
  $MENU_TOGGLE = $('#menu_toggle'),
  $SIDEBAR_MENU = $('#sidebar-menu'),
  $SIDEBAR_FOOTER = $('.sidebar-footer'),
  $LEFT_COL = $('.left_col'),
  $RIGHT_COL = $('.right_col'),
  $NAV_MENU = $('.nav_menu'),
  $FOOTER = $('footer')

// Sidebar
function logo_toggle() {
  var sidebarWidth = $('#sidebar-menu').width()

  if (sidebarWidth > 100) {
    $('.desk_title').show()
    $('.mob_title').hide()
    $('.nav_menu').css('padding-bottom', 'inherit')
  } else {
    $('.mob_title').show()
    $('.desk_title').hide()

    $('.nav_menu').css('padding-bottom', '20px')

  }
}

function init_sidebar() {

  logo_toggle()
  /* $(window).resize(function(){

   logo_toggle()
   let winwidth = $(window).width();
   ;
   if(winwidth < 992)
   {
   if ($BODY.hasClass('nav-md')) {
   $SIDEBAR_MENU.find('li.active ul').hide()
   $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active')
   } else {
   $SIDEBAR_MENU.find('li.active-sm ul').show()
   $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm')
   }

   $('body').toggleClass('nav-md nav-sm')

   setContentHeight()
   logo_toggle()
   }



   });*/
  var setContentHeight = function () {
    // reset height
    $RIGHT_COL.css('min-height', $(window).height())

    var bodyHeight = $BODY.outerHeight(),
      footerHeight = $BODY.hasClass('footer_fixed') ? -10 : $FOOTER.height(),
      leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
      contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight

    // normalize content
    contentHeight -= $NAV_MENU.height() + footerHeight

    $RIGHT_COL.css('min-height', contentHeight)
  }

  $('#sidebar-menu').find('a').on('click', function (ev) {

    var context = this

    var $li = $(context).parent()

    if ($li.is('.active')) {

      $li.removeClass('active active-sm')
      $('ul:first', $li).slideUp(function () {

        setContentHeight()
      })
    } else {
      // prevent closing menu if we are on child menu
      if (!$li.parent().is('.child_menu')) {

        $('#sidebar-menu').find('li').removeClass('active active-sm')
        $('#sidebar-menu').find('li ul').slideUp()
      } else {
        if ($('body').is('.nav-sm')) {
          $('#sidebar-menu').find('li').removeClass('active active-sm')
          $('#sidebar-menu').find('li ul').slideUp()
        }
      }

      $li.parent().find('.active').removeClass('active')
      $li.addClass('active')

      $('ul:first', $li).slideDown(function () {
        setContentHeight()
      })
    }

  })

  // toggle small or large menu
  $('#menu_toggle').on('click', function () {;
    if ($(window).width() < 1000) {
      $('.desk_title').show()
      if ($('.left_col:visible').is(':visible')) {
        $('.left_col').css('display', 'none');
      } else {
        $('.left_col').css('display', 'block');
      }
      //setContentHeight()
      // $('body').toggleClass('nav-md nav-sm')


      return;
    }



    if ($BODY.hasClass('nav-md')) {

      $SIDEBAR_MENU.find('li.active ul').hide()
      $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active')
    } else {
      $SIDEBAR_MENU.find('li.active-sm ul').show()
      $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm')
    }

    /* $('body').toggleClass('nav-md nav-sm')*/

    $('.left_col').toggleClass('sidehide nav-md')

    $('body').toggleClass('nav-md')
    $('.right_col').toggleClass('rcolwidth')
    $('.nav_menu').toggleClass('rcolwidth')
    $('.top_nav').toggleClass('topnavcola')
    $('footer').toggleClass('footer_full')

    setContentHeight()

    logo_toggle()
    /*    $('.dataTable').each(function () { $(this).dataTable().fnDraw() })*/
  })

  // check active menu
  $SIDEBAR_MENU.find('a[href="' + CURRENT_URL + '"]').parent('li').addClass('current-page')

  $SIDEBAR_MENU.find('a').filter(function () {
    return this.href == CURRENT_URL
  }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
    setContentHeight()
  }).parent().addClass('active')

  // recompute content when resizing
  $(window).smartresize(function () {
    setContentHeight()
  })

  setContentHeight()

  // fixed sidebar
  if ($.fn.mCustomScrollbar) {
    $('.menu_fixed').mCustomScrollbar({
      autoHideScrollbar: true,
      theme: 'minimal',
      mouseWheel: {
        preventDefault: true
      }
    })
  }
}
// /Sidebar

var randNum = function () {
  return (Math.floor(Math.random() * (1 + 40 - 20))) + 20
}

// Panel toolbox
$(document).ready(function () {
  $('.collapse-link').on('click', function () {
    var $BOX_PANEL = $(this).closest('.x_panel'),
      $ICON = $(this).find('i'),
      $BOX_CONTENT = $BOX_PANEL.find('.x_content')

    // fix for some div with hardcoded fix class
    if ($BOX_PANEL.attr('style')) {
      $BOX_CONTENT.slideToggle(200, function () {
        $BOX_PANEL.removeAttr('style')
      })
    } else {
      $BOX_CONTENT.slideToggle(200)
      $BOX_PANEL.css('height', 'auto')
    }

    $ICON.toggleClass('fa-chevron-up fa-chevron-down')
  })

  $('.close-link').click(function () {
    var $BOX_PANEL = $(this).closest('.x_panel')

    $BOX_PANEL.remove()
  })
})

/* AUTOSIZE */

function init_autosize() {

  if (typeof $.fn.autosize !== 'undefined') {

    autosize($('.resizable_textarea'))

  }

}

/* INPUTS */

function onAddTag(tag) {
  alert('Added a tag: ' + tag)
}

function onRemoveTag(tag) {
  alert('Removed a tag: ' + tag)
}

function onChangeTag(input, tag) {
  alert('Changed a tag: ' + tag)
}

//tags input
function init_TagsInput() {

  if (typeof $.fn.tagsInput !== 'undefined') {

    $('#tags_1').tagsInput({
      width: 'auto'
    })

  }

}

/* WYSIWYG EDITOR */

function init_wysiwyg() {

  if (typeof ($.fn.wysiwyg) === 'undefined') {
    return
  }
  console.log('init_wysiwyg')

  function init_ToolbarBootstrapBindings() {
    var fonts = ['Serif', 'Sans', 'Arial', 'Arial Black', 'Courier',
        'Courier New', 'Comic Sans MS', 'Helvetica', 'Impact', 'Lucida Grande', 'Lucida Sans', 'Tahoma', 'Times',
        'Times New Roman', 'Verdana'
      ],
      fontTarget = $('[title=Font]').siblings('.dropdown-menu')
    $.each(fonts, function (idx, fontName) {
      fontTarget.append($('<li><a data-edit="fontName ' + fontName + '" style="font-family:\'' + fontName + '\'">' + fontName + '</a></li>'))
    })
    $('a[title]').tooltip({
      container: 'body'
    })
    $('.dropdown-menu input').click(function () {
        return false
      })
      .change(function () {
        $(this).parent('.dropdown-menu').siblings('.dropdown-toggle').dropdown('toggle')
      })
      .keydown('esc', function () {
        this.value = ''
        $(this).change()
      })

    $('[data-role=magic-overlay]').each(function () {
      var overlay = $(this),
        target = $(overlay.data('target'))
      overlay.css('opacity', 0).css('position', 'absolute').offset(target.offset()).width(target.outerWidth()).height(target.outerHeight())
    })

    if ('onwebkitspeechchange' in document.createElement('input')) {
      var editorOffset = $('#editor').offset()

      $('.voiceBtn').css('position', 'absolute').offset({
        top: editorOffset.top,
        left: editorOffset.left + $('#editor').innerWidth() - 35
      })
    } else {
      $('.voiceBtn').hide()
    }
  }

  $('.editor-wrapper').each(function () {
    var id = $(this).attr('id') //editor-one

    $(this).wysiwyg({
      toolbarSelector: '[data-target="#' + id + '"]',
      fileUploadError: showErrorAlert
    })
  })

  window.prettyPrint
  prettyPrint()

}

function init_PNotify() {

  if (typeof (PNotify) === 'undefined') {
    return
  }
  console.log('init_PNotify')

  new PNotify({
    title: 'PNotify',
    type: 'info',
    text: 'Welcome. Try hovering over me. You can click things behind me, because I\'m non-blocking.',
    nonblock: {
      nonblock: true
    },
    addclass: 'dark',
    styling: 'bootstrap3',
    hide: false,
    before_close: function (PNotify) {
      PNotify.update({
        title: PNotify.options.title + ' - Enjoy your Stay',
        before_close: null
      })

      PNotify.queueRemove()

      return false
    }
  })

}

/* CUSTOM NOTIFICATION */

function init_CustomNotification() {

  console.log('run_customtabs')

  if (typeof (CustomTabs) === 'undefined') {
    return
  }
  console.log('init_CustomTabs')

  var cnt = 10

  TabbedNotification = function (options) {
    var message = '<div id=\'ntf' + cnt + '\' class=\'text alert-' + options.type + '\' style=\'display:none\'><h2><i class=\'fa fa-bell\'></i> ' + options.title +
      '</h2><div class=\'close\'><a href=\'javascript:;\' class=\'notification_close\'><i class=\'fa fa-close\'></i></a></div><p>' + options.text + '</p></div>'

    if (!document.getElementById('custom_notifications')) {
      alert('doesnt exists')
    } else {
      $('#custom_notifications ul.notifications').append('<li><a id=\'ntlink' + cnt + '\' class=\'alert-' + options.type + '\' href=\'#ntf' + cnt + '\'><i class=\'fa fa-bell animated shake\'></i></a></li>')
      $('#custom_notifications #notif-group').append(message)
      cnt++
      CustomTabs(options)
    }
  }

  CustomTabs = function (options) {
    $('.tabbed_notifications > div').hide()
    $('.tabbed_notifications > div:first-of-type').show()
    $('#custom_notifications').removeClass('dsp_none')
    $('.notifications a').click(function (e) {
      e.preventDefault()
      var $this = $(this),
        tabbed_notifications = '#' + $this.parents('.notifications').data('tabbed_notifications'),
        others = $this.closest('li').siblings().children('a'),
        target = $this.attr('href')
      others.removeClass('active')
      $this.addClass('active')
      $(tabbed_notifications).children('div').hide()
      $(target).show()
    })
  }

  CustomTabs()

  var tabid = idname = ''

  $(document).on('click', '.notification_close', function (e) {
    idname = $(this).parent().parent().attr('id')
    tabid = idname.substr(-2)
    $('#ntf' + tabid).remove()
    $('#ntlink' + tabid).parent().remove()
    $('.notifications a').first().addClass('active')
    $('#notif-group div').first().css('display', 'block')
  })

}

/* COMPOSE */

function init_compose() {

  if (typeof ($.fn.slideToggle) === 'undefined') {
    return
  }
  console.log('init_compose')

  $('#compose, .compose-close').click(function () {
    $('.compose').slideToggle()
  })

}

window.isTri = false

$(document).ready(function () {

  if (!window.isTri) {
    init_sidebar()
  }

})



$(document).on('newMessage', function () {
  window.isTri = true
  setTimeout(function () {

    init_sidebar()
    logo_toggle()
  }, 200)

})



// WEBPACK FOOTER //
// ./src/assets/js/site.scripts.js